import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AnalyticEvents } from '@app/enums';
import { AnalyticService, NotifyService } from '@app/services';
import { Translatable } from '@app/types/translatable.type';
import { SimplyBenefitsService } from '@benefits/services';
import { environment } from '@env/environment';
import { Employee } from '@models/employee/employee.model';

@Component({
    selector: 'app-benefit-details-simply-benefits',
    templateUrl: './benefit-details-simply-benefits.template.html',
    styleUrls: ['./benefit-details-simply-benefits.style.scss'],
})
export class BenefitDetailsSimplyBenefits implements OnInit {
    @Output() isLoading: EventEmitter<boolean> = new EventEmitter<boolean>();

    employee: Employee;
    benefitClass: string;
    division: string;
    waiveEligibilityPeriod: Translatable;
    simplyBenefitsAdminUrl = environment.simplyBenefitsAdminPanelUrl;

    constructor(
        private route: ActivatedRoute,
        private notify: NotifyService,
        private simplyBenefitsService: SimplyBenefitsService,
        private analyticsService: AnalyticService
    ) {
        this.employee = this.route.snapshot.data.models.get('employee');
    }

    async ngOnInit(): Promise<void> {
        if (!this.employee?.hasSimplyBenefits) {
            this.isLoading.emit(false);
            return;
        }

        this.isLoading.emit(true);

        try {
            const member = await this.simplyBenefitsService.getMember(this.employee.id);
            const simplyBenefitsClass = await this.simplyBenefitsService.getClass(member.classID);
            const simplyBenefitsDivision = await this.simplyBenefitsService.getDivision(member.divisionID);

            this.benefitClass = simplyBenefitsClass.title;
            this.division = simplyBenefitsDivision.title;
            this.waiveEligibilityPeriod = member.waiveEligibilityPeriod
                ? 'benefits.waiveEligibilityPeriod'
                : 'benefits.doNotWaiveEligibilityPeriod';
        } catch (e) {
            this.notify.error(e);
        } finally {
            this.isLoading.emit(false);
        }
    }

    trackSimplyPortalLinkEvent(): void {
        this.analyticsService.trackEvent(AnalyticEvents.SimplyBenefitsEmployeeProfileThenAccessAdminPortal);
    }
}
